import { actions } from './actions';

const INITIAL_STATE = {
  pages: [],
  currentPage: {},
  currentPageVersion: {},
  loading: true,
  versionLoading: false,
  pagesCreating: [],
};

export default function webReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case actions.RESET:
      return INITIAL_STATE;
    case actions.ALL_PAGES_SUCCESS:
      return { ...state, pages: payload };
    case actions.PAGE_SUCCESS:
      return { ...state, currentPage: payload };
    case actions.CURRENT_VERSION_SUCCESS:
      return { ...state, currentPageVersion: payload };
    case actions.SHOW_LOADING:
      return { ...state, loading: true };
    case actions.HIDE_LOADING:
      return { ...state, loading: false };
    case actions.TOGGLE_VERSION_LOADING:
      return { ...state, versionLoading: payload };
    case actions.PUSH_PAGES_CREATING:
      return {
        ...state,
        pagesCreating: [...state.pagesCreating, payload],
      };
    case actions.POP_PAGES_CREATING:
      return {
        ...state,
        pagesCreating: state.pagesCreating.filter((i) => i !== payload),
      };
    default:
      return state;
  }
}
